import React from 'react';
import { Card, Col, Divider, Row, Skeleton, Space } from 'antd';

export const OrderDetailPanelSkeleton: React.FC = () => (
  <div style={{ padding: '16px 24px' }}>
    <Row gutter={[24, 16]}>
      <Col xs={24} lg={7}>
        <Card bodyStyle={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Skeleton.Image active />
        </Card>
        <Card size="small" style={{ marginTop: 12 }}>
          <Skeleton active title={false} paragraph={{ rows: 8 }} />
        </Card>
      </Col>
      <Col xs={24} lg={17}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
          <Skeleton.Input active size="large" style={{ width: '55%' }} />
        </div>
        <Space style={{ marginBottom: 12 }}>
          <Skeleton.Button active size="small" style={{ width: 90 }} />
        </Space>
        <Skeleton active paragraph={{ rows: 3 }} />
        <Divider />
        <Skeleton active title={false} paragraph={{ rows: 5 }} style={{ marginTop: 16 }} />
        <Skeleton active title={false} paragraph={{ rows: 4 }} style={{ marginTop: 16 }} />
        <Divider />
        <Skeleton active title={false} paragraph={{ rows: 2 }} />
        <Skeleton.Input active style={{ width: '100%', marginTop: 8 }} />
      </Col>
    </Row>
  </div>
);
